// #/services/registry/openApi/utils/serviceDetailsFromService.ts

import { OpenApiSchemaJson } from '#/types/registry';
import domainNameFromUrl from '#/utils/domainNameFromUrl';

function mapDomainToLogoDomain(domain) {
  const parts = domain.split('.');
  const tld = parts[parts.length - 1];
  const root = parts[parts.length - 2];
  const subdomain = parts.slice(0, parts.length - 2).join('.');

  const rootDomain = `${root}.${tld}`;

  if (rootDomain === 'googleapis.com') {
    return 'google.com';
  }

  return domain;
}

function logoUrlFromUrlRoot(urlRoot?: string) {
  if (urlRoot == null) {
    return;
  }
  const domainName = domainNameFromUrl(urlRoot);
  const logoDomain = mapDomainToLogoDomain(domainName);
  return `https://logo.clearbit.com/${logoDomain}?size=256`;
}

export function serviceDetailsFromService(service: OpenApiSchemaJson) {
  const serviceUrlRoot = service?.servers?.[0]?.url;
  const serviceLogoUrl = logoUrlFromUrlRoot(serviceUrlRoot);
  return {
    // TODO
    name: service?.info?.title,
    description: service?.info?.description,
    serviceUrlRoot,
    serviceLogoUrl,
    ...service,
  };
}

export default serviceDetailsFromService;
